import { Link } from "react-router-dom";
// import "../../assets/css/PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <section className="paragraph">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="privacy-policy-header">
              <h2 className="main-title">Privacy Policy</h2>
              <p className="privacy-policy-meta">
                <strong>Effective Date:</strong> <em>1st Sep 2025</em>
                <br />
                <strong>Last Updated:</strong> <em>1st Mar 2026</em>
              </p>

              <p>
                Broward Partnerships for Kids ("we," "us," or "our") respects
                your privacy and is committed to protecting the personal
                information you provide when using the Broward Partnerships for
                Kids website at results4broward (the "Website").
              </p>
              <p>
                This Privacy Policy explains what information we may collect,
                how we use and protect that information, when information may be
                shared, and the choices available to you.
              </p>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">1</span>
                <h3>Information We Collect</h3>
              </div>
              <p>
                Depending on how you use the Website, we may collect information
                that you voluntarily provide, such as:
              </p>
              <ul>
                <li>First and last name</li>
                <li>Email address</li>
                <li>Telephone number</li>
                <li>Organization or employer information</li>
                <li>
                  Information submitted through forms or other Website features
                </li>
                <li>Account or authentication information, if applicable</li>
                <li>Any other information you voluntarily provide to us</li>
              </ul>
              <p>
                We may also automatically collect certain technical information
                when you visit or use the Website, including:
              </p>
              <ul>
                <li>IP address</li>
                <li>Browser type and version</li>
                <li>Device type</li>
                <li>Operating system</li>
                <li>Date and time of access</li>
                <li>Pages or features accessed</li>
                <li>Referring website or page</li>
                <li>
                  Other technical information necessary to operate, maintain,
                  and secure the Website
                </li>
              </ul>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">2</span>
                <h3>How We Use Information</h3>
              </div>
              <p>We may use information collected through the Website to:</p>
              <ul>
                <li>Provide and operate Website services</li>
                <li>Respond to questions, requests, and communications</li>
                <li>Process information submitted through the Website</li>
                <li>Maintain and improve Website functionality</li>
                <li>Monitor Website performance and security</li>
                <li>Detect and prevent fraud, abuse, or unauthorized access</li>
                <li>Communicate with users regarding Website services</li>
                <li>
                  Comply with applicable legal and regulatory requirements
                </li>
                <li>
                  Fulfill other purposes disclosed at the time information is
                  collected
                </li>
              </ul>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">3</span>
                <h3>Cookies and Similar Technologies</h3>
              </div>
              <p>
                The Website may use cookies and similar technologies to support
                Website functionality, security, analytics, and user
                preferences. Cookies may allow us to understand how visitors use
                the Website and help us improve the user experience.
              </p>
              <p>
                You may be able to control or disable cookies through your
                browser settings. Disabling certain cookies may affect the
                functionality of portions of the Website.
              </p>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">4</span>
                <h3>How We Share Information</h3>
              </div>
              <p>
                We do not sell personal information for monetary consideration.
              </p>
              <p>
                We may share information with trusted service providers,
                contractors, technology providers, or other organizations that
                assist us in operating and maintaining the Website and providing
                related services.
              </p>
              <p>We may also disclose information:</p>
              <ul>
                <li>
                  When required by law, regulation, legal process, or
                  governmental request
                </li>
                <li>
                  To protect the rights, safety, or property of Broward
                  Partnerships for Kids, Website users, or others
                </li>
                <li>
                  To investigate fraud, security incidents, or unauthorized
                  activity
                </li>
                <li>
                  In connection with a merger, acquisition, reorganization, or
                  transfer of assets
                </li>
                <li>With your consent or at your direction</li>
              </ul>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">5</span>
                <h3>Data Security</h3>
              </div>
              <p>
                We use reasonable administrative, technical, and organizational
                measures designed to protect personal information against
                unauthorized access, disclosure, alteration, or destruction.
              </p>
              <p>
                However, no method of transmitting or storing information over
                the Internet can be guaranteed to be completely secure.
                Therefore, we cannot guarantee absolute security of information
                transmitted to or stored by the Website.
              </p>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">6</span>
                <h3>Data Retention</h3>
              </div>
              <p>
                We retain personal information only for as long as reasonably
                necessary to fulfill the purposes described in this Privacy
                Policy, provide requested services, maintain business and
                operational records, resolve disputes, enforce agreements, and
                comply with applicable legal obligations.
              </p>
              <p>
                Specific retention periods may vary depending on the type of
                information and the purpose for which it was collected.
              </p>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">7</span>
                <h3>Third-Party Services and Links</h3>
              </div>
              <p>
                The Website may use third-party services to support hosting,
                authentication, analytics, security, communications, or other
                Website functions.
              </p>
              <p>
                The Website may also contain links to third-party websites.
                Third-party websites operate independently and may have their
                own privacy policies and practices.
              </p>
              <p>
                We encourage users to review the privacy policies of third-party
                websites before providing personal information.
              </p>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">8</span>
                <h3>Children's Privacy</h3>
              </div>
              <p>
                The Website is not intended to knowingly collect personal
                information from children except where permitted or required for
                the services provided.
              </p>
              <p>
                If we become aware that personal information has been collected
                from a child in a manner that violates applicable law, we will
                take appropriate steps to address the situation.
              </p>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">9</span>
                <h3>Your Privacy Rights</h3>
              </div>
              <p>
                Depending on your location and applicable law, you may have
                certain rights regarding your personal information, which may
                include the right to:
              </p>
              <ul>
                <li>
                  Request access to personal information we maintain about you
                </li>
                <li>Request correction of inaccurate information</li>
                <li>
                  Request deletion of personal information, where legally
                  permitted
                </li>
                <li>
                  Request information about how your personal information is
                  used or disclosed
                </li>
                <li>Object to or restrict certain processing</li>
                <li>Withdraw consent where processing is based on consent</li>
                <li>Request a copy of certain personal information</li>
              </ul>
              <p>
                To submit a privacy-related request, please contact us using the
                information provided below.
              </p>
              <p>
                We may need to verify your identity before completing certain
                requests.
              </p>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">10</span>
                <h3>Do Not Track</h3>
              </div>
              <p>
                Some web browsers offer a "Do Not Track" setting. Because there
                is currently no universally accepted standard for responding to
                Do Not Track signals, the Website may not respond to such
                signals unless required by applicable law.
              </p>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">11</span>
                <h3>Changes to This Privacy Policy</h3>
              </div>
              <p>
                We may update this Privacy Policy from time to time to reflect
                changes in our Website, services, legal requirements, or privacy
                practices.
              </p>
              <p>
                When we make changes, we will update the Last Updated date at
                the top of this Privacy Policy.
              </p>
              <p>
                We encourage you to periodically review this Privacy Policy to
                stay informed about how we handle personal information.
              </p>
            </div>

            <div className="policy-card">
              <div className="policy-card-title">
                <span className="policy-card-number">12</span>
                <h3>Contact Us</h3>
              </div>
              <p>
                If you have questions about this Privacy Policy or our privacy
                practices, or if you wish to submit a privacy request, please
                contact:
              </p>
              <p>
                Broward Partnerships for Kids
                <br />
                Email: <em>help@browardpartnershipsforkids.org</em>
                <br />
                Address:{" "}
                <em>6600 West Commercial Boulevard Lauderhill, FL 33319</em>
                <br />
                Phone: <em>(954) 377-1000</em>
              </p>
            </div>

            <div className="div-center mt-4">
              <Link to="/Home" className="cta-button min-width-none">
                Back
                <i className="arrow-icon-btn bi bi-arrow-left"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
